import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EditDeleteActionsRenderer } from "../../../shared/ag-grid/cell-renderers/edit-delete.component";
import { ColumnApi, GridApi, GridReadyEvent, GridOptions } from "ag-grid-community";
import { ZoneService } from "src/app/services/zone.service";
import { GeoService } from "src/app/services/geo.service";
import { VendorService } from "src/app/services/vendor.service";
import { ProductService } from "src/app/services/products.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import Swal from "sweetalert2";
import { Utilities } from "src/app/models/utilities";
import { saveAs } from 'file-saver-es';
import { FileHandlerService } from "src/app/services/file-handler.service";
import { HttpHeaders } from "@angular/common/http";
import { AppCoreService } from "src/app/services/app-core.service";
import { EditViewDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/delete-view.component";
import { ZoneDetailComponent } from "./detail/zonedetails.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ZoneperiodComponent } from "./period/zoneperiod.component";
import { ExcelService } from "src/app/services/excel.service";
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.scss']
})

export class ZoneLinkComponent implements OnInit, AfterViewInit {
  isAddAllowed = false;
  zoneForm: FormGroup;
  zoneLinkAddForm: FormGroup;


  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted = false;
  isZoneAddFormSubmitted = false;
  isEdit = false;
  vendorList: any = [];
  productList: any = [];
  zoneList: any = [];
  countryList: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  zoneId: number;
  selectedFile: File | null = null;
  fileType: any;
  isFileUploaded = false;
  isDownloading = false;
  isZoneAdd = false;
  showProgressBar = false;
  progress: number = 0;

  // new added variable here 
  showRateDetails = false;
  rowDataPeriod = [];
  zoneDetailId: any;


  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;

  defaultColDef = {
    sortable: true,
    resizable: false,
    filter: true
  };

  gridOptionsPeriod: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 5
  }

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight'
  }


  // columnDefs = [
  //     { headerName: 'Sr No.', field: 'id' },
  //     { headerName: 'Product', field: 'productcode' },
  //     { headerName: 'Country', field: 'country' },
  //     { headerName: 'State', field: 'state' },
  //     { headerName: 'City', field: 'city' },
  //     { headerName: 'Zone', field: 'zonecode' },
  //     {
  //         headerName: 'Actions',
  //         field: 'id',
  //         cellRenderer: EditDeleteActionsRenderer,
  //         cellClass: "actions-button-cell",
  //         cellStyle: { "overflow": 'visible' },
  //         colId: 'params',
  //         editable: false,
  //         sortable: false,
  //         minWidth: 150,
  //         filter: false
  //     },
  // ]

  columnDefsPeriod = [

    { headerName: 'From Date', field: 'fromdate' },
    { headerName: 'To Date', field: 'todate' },
    { headerName: 'Vendor', field: 'vendor' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditViewDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 100,
    },
  ];
  columnDefs = [
    { headerName: 'Product', field: 'productcode', minWidth: 90 },
    { headerName: 'Vendor', field: 'vendor', minWidth: 90 },
    { headerName: 'Origin Country', field: 'origincountrycode', minWidth: 150 },
    { headerName: 'Origin State', field: 'originstatecode', minWidth: 120 },
    { headerName: 'Origin City', field: 'origincitycode', minWidth: 120 },
    { headerName: 'Origin Pincode From', field: 'originpincodefrom', minWidth: 160 },
    { headerName: 'Origin Pincode To', field: 'originpincodeto', minWidth: 160 },
    { headerName: 'Destination Country', field: 'destinationcountrycode', minWidth: 150 },
    { headerName: 'Destination State', field: 'destinationstatecode', minWidth: 140 },
    { headerName: 'Destination City', field: 'destinationcitycode', minWidth: 140 },
    { headerName: 'Destination Pincode From', field: 'destinationpincodefrom', minWidth: 190 },
    { headerName: 'Destination Pincode To', field: 'destinationpincodeto', minWidth: 180 },
    { headerName: 'Service', field: 'service', minWidth: 160 },
    {
      headerName: 'Destination Zone', field: 'zonecode',
      minWidth: 140,
      pinned: 'right'
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      filter: false,
      sortable: false,
      minWidth: 100,
      pinned: 'right'
    },
  ];

  rowData = [];
  useEnterKey: any;

  constructor(
    private appCoreService: AppCoreService,
    private formBuilder: FormBuilder,
    private utilities: Utilities,
    private zoneService: ZoneService,
    private geoService: GeoService,
    private vendorService: VendorService,
    private productService: ProductService,
    private ngxLoaderService: NgxUiLoaderService,
    private fileHandlerService: FileHandlerService,
    public modalService: NgbModal,
    private excelService: ExcelService,
    private titleService: Title
  ) {
    titleService.setTitle('Zones');
    this.context = { componentParent: this, actionConfig: { edit: true } };
  }

  ngOnInit(): void {
    this.zoneForm = this.formBuilder.group({
      ddlVendor: [null, Validators.required],
      fileControl: [null, Validators.required],
      txtFromDate: [null, Validators.required],
      txtToDate: [null, Validators.required],
    });
    this.zoneLinkAddForm = this.formBuilder.group({
      ddlZone: [[], Validators.compose([Validators.required])],
      ddlCountry: [null, Validators.compose([Validators.required])],
      ddlState: [],
      ddlCity: [],
      ddlProduct: []
    });
    this.checkPermission();
    if (this.permConfig.isAddAllowed || this.permConfig.isEditAllowed) {
      // this.bindCountry();
      this.bindVendor();
      // this.bindProduct();
      this.bindZonePeriod();
    }

  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.zoneForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Zones');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  // bindCountry() {
  //     this.geoService.GetAllCountries().subscribe((res) => {
  //         this.countryList = res?.data ? res.data : null;
  //     });
  //}

  bindVendor() {
    this.vendorService.GetAll({ isactive: this.isEdit ? false : true }).subscribe((res) => {
      this.vendorList = res?.data ? res.data : null;
    })
  }

  bindProduct() {
    this.productService.GetAll({ isactive: this.isEdit ? false : true }).subscribe((res) => {
      this.productList = res?.data ? res.data : null;
    })
  }

  bindZonePeriod(refresh = false) {
    this.zoneService.GetAllPeriod({ refresh: refresh }).subscribe((res) => {
      this.rowDataPeriod = null;
      this.rowDataPeriod = res?.data ? res.data : null;
    })
  }

  // onCountryChange() {
  //     const country = this.zoneLinkAddForm.get('ddlCountry').value;
  //     if (country)
  //         this.bindStatesByCountry(country);
  //     this.zoneLinkAddForm.get('ddlState').reset();
  //     this.zoneLinkAddForm.get('ddlCity').reset();
  // }
  bindZone() {
    this.zoneService.GetAll({ isactive: true }).subscribe((res) => {
      this.zoneList = res?.data ? res.data : null;
    })
  }

  onCountryChange() {
    const country = this.zoneLinkAddForm.get('ddlCountry').value;
    if (country)
      this.bindStatesByCountry(country);
    this.zoneLinkAddForm.get('ddlState').reset();
    this.zoneLinkAddForm.get('ddlCity').reset();
  }

  bindStatesByCountry(countryCode?: string) {
    try {
      if (countryCode)
        this.geoService.GetAllStates({ countrycode: countryCode }).subscribe((res) => {
          this.stateList = res?.data ? res.data : null;
        });
    } catch (e) {
      console.error(e);
    }
  }

  // onStateChange() {
  //     const state = this.zoneLinkAddForm.get('ddlState').value;
  //     if (state)
  //         this.bindCitiesByState(state);
  //     this.zoneLinkAddForm.get('ddlCity').reset();
  // }

  // bindCitiesByState(stateCode?: string) {
  //     try {
  //         if (stateCode)
  //             this.geoService.GetAllCities({ statecode: stateCode }).subscribe((res) => {
  //                 this.cityList = res?.data ? res.data : null;
  //             });
  //     } catch (e) {
  //         console.error(e);
  //     }
  // }

  // onVendorChange() {
  //     const vendor = this.zoneForm.get('ddlVendor').value;
  //     this.ngxLoaderService.start();
  //     if (vendor) {
  //         this.zoneService.GetVendor(vendor).subscribe((res) => {
  //             this.ngxLoaderService.stop();
  //             this.rowData = res?.data ? res.data : null;
  //             this.resetZone();
  //         });
  //     }

  //     this.ngxLoaderService.stop();
  // }


  async downloadFormatFile() {
    try {
      this.isDownloading = true;
      const fileDomainURL = this.utilities.getS3DownloadURL();
      let fileName = '';
      let downloadFileURL = '';
      let filePath = 'zones/ZoneLinking.xlsx';

      if (filePath) {
        fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
      }
      downloadFileURL = `${fileDomainURL}${filePath}`;

      //   console.log('downloadFileURL: ', downloadFileURL);
      // const link = document.createElement('a');
      // link.setAttribute('target', '_blank');
      // link.setAttribute('href', downloadFileURL);
      // link.setAttribute('download', downloadFileURL);
      // document.body.appendChild(link);
      // link.click();
      // link.remove();

      saveAs(downloadFileURL, fileName);
      setTimeout(() => {
        this.isDownloading = false;
      }, 1000);
    } catch (e) {
      console.log(e);
    }
  }

  onChangeFileSelect(evt) {
    try {
      if (evt) {
        this.selectedFile = evt.target.files[0];
      }
    } catch (e) {
      console.error(e);
    }
  }

  uploadZoneLinks() {
    let interval: any;
    let timeout: any;
    this.isFormSubmitted = true;
    if (this.zoneForm.valid) {
    
      if (this.selectedFile) {
        let isZonePeriodNotValid = false;
        let rateRequestObj = {
          fromdate: this.zoneForm.get('txtFromDate').value,
          todate: this.zoneForm.get('txtToDate').value,
          vendorid: this.zoneForm.get('ddlVendor').value,
        };
        clearInterval(interval);
        clearTimeout(timeout);

        this.showProgressBar = true;
        this.progress = 0;
        interval = setInterval(() => {
          if (this.progress < 99) {
            this.progress += 1;
          }
        }, 100);
        timeout = setTimeout(() => {
          if (this.progress >= 99 && this.progress < 100) {
            this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
            this.showProgressBar = false;
            clearInterval(interval);
          }
        }, 5000);

        this.zoneService.CheckZonePeriod(rateRequestObj).subscribe(res => {
          try {
            if (res && res.success) {
              this.progress = 100;
              clearInterval(interval);
              clearTimeout(timeout);
              setTimeout(() => {
                this.showProgressBar = false;
              }, 1000);
              this.ngxLoaderService.stop();
              isZonePeriodNotValid = res.data?.err_msg;
              if (isZonePeriodNotValid) {
                this.isFormSubmitted = false;
                this.appCoreService.showMessage(res.message, 'Error', 'error')
              } else {
                let requestObj = {
                  name: this.selectedFile.name,
                  fileType: this.selectedFile.type,
                  category: 'zones'
                };

                // get signed url and upload file
                this.ngxLoaderService.start();
                this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
                  try {
                    if (res && res.success) {
                      const signedUrl = res.data.uploadURL;
                      const fileId = res.data.fileId;
                      if (signedUrl) {
                        let headers: HttpHeaders = new HttpHeaders({
                          "Content-Type": requestObj.fileType
                        });
                        this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                          if (f === null) {
                            this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                              if (res && res.success) {
                                this.ngxLoaderService.stop();
                                this.processFile(fileId);
                                this.progress = 100;
                                clearInterval(interval);
                                clearTimeout(timeout);
                                setTimeout(() => {
                                  this.showProgressBar = false;
                                }, 1000);
                              }
                            });
                          }
                        });
                      }
                    }

                    this.ngxLoaderService.stop();
                  } catch (error) {
                    console.error(error);
                    this.ngxLoaderService.stop();
                  }
                });
              }
            }
          } catch (error) {
            console.error(error);
            this.ngxLoaderService.stop();
          }
        });

      } else {
        console.log('No file selected');
      }
    }
  }

  processFile(fileId) {
    try {
      const requestObj = {
        fileId,
        vendor: this.zoneForm.get('ddlVendor').value,
        fromdate: this.zoneForm.get('txtFromDate').value,
        todate: this.zoneForm.get('txtToDate').value,
      }
      this.ngxLoaderService.start();
      this.zoneService.UploadZone(requestObj).subscribe(res => {
        try {
          if (res && res.success) {
            this.isFormSubmitted = false;
            this.zoneForm.reset();
            (document.getElementById('importzones') as HTMLInputElement).value = '';
            this.ngxLoaderService.stop();
            this.successDialog("Zone linking uploaded successfully");
            this.bindZonePeriod();
          }
          if (res && !res.success) {
            this.isFormSubmitted = false;
            this.zoneForm.reset();
            (document.getElementById('importzones') as HTMLInputElement).value = '';
            this.ngxLoaderService.stop();
            this.warningExcelDialog(res.message, res?.data);
          }
        } catch (error) {
          console.error(error);
          this.ngxLoaderService.stop();
          this.isFormSubmitted = false;
          this.zoneForm.reset();
          (document.getElementById('importzones') as HTMLInputElement).value = '';
        }
      });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  async warningExcelDialog(msg: any, data: any) {
    const isHtml = msg.includes('<') && msg.includes('>');
    const confirmText = isHtml ? '<i class="bx bx-download"></li> Download' : null;
    const res = await Swal.fire({
      title: 'Warning!',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'warning',
      confirmButtonText: confirmText,
      showCloseButton: true,
      showConfirmButton: isHtml,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (res.isConfirmed && data) {
      this.excelService.exportAsExcelFile(data, "Zone_Errors_Import");
    }
  }


  async successDialog(msg?: any) {
    const success = await Swal.fire({
      titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (success.isConfirmed) {
      this.isFormSubmitted = false;
      this.zoneForm.reset();
    }
  }



  // addZoneLink() {
  //     this.isZoneAddFormSubmitted = true;
  //     if (this.zoneLinkAddForm.valid) {

  //     }
  // }

  // editAction(cell: any) {
  //     try {
  //         if (!this.permConfig.isEditAllowed) {
  //             this.openWarningDialog('No access to Edit.');
  //         }
  //         else if (this.permConfig.isEditAllowed && cell) {
  //             this.getZone(cell);
  //         }
  //     } catch (e) {
  //         console.error(e);
  //     }
  // }

  // getZone(data: any) {
  //     this.zoneId = data.id;
  //     this.bindStatesByCountry(data.country);
  //     this.bindCitiesByState(data.state);
  //     this.zoneLinkAddForm.patchValue({
  //         ddlProduct: data.productcode,
  //         ddlZone: data.zonecode,
  //         ddlCountry: data.country,
  //         ddlState: data.state,
  //         ddlCity: data.city
  //     });
  //     this.isEdit = true;
  // }

  // addZone() {
  //     this.isZoneAddFormSubmitted = true;
  //     this.isFormSubmitted = true;
  //     if (!this.permConfig.isAddAllowed) {
  //         this.openWarningDialog('No access to Add.');
  //         return;
  //     }
  //     const zonecode = this.zoneLinkAddForm.get('ddlZone').value;
  //     const countrycode = this.zoneLinkAddForm.get('ddlCountry').value;
  //     const vendorcode = this.zoneForm.get('ddlVendor').value;

  //     if (!zonecode && !countrycode || !vendorcode) {
  //         return;
  //     }
  //     this.isZoneAdd = true;
  //     const reqObj: any = {
  //         vendorcode: this.zoneForm.get('ddlVendor').value,
  //         zonecode: this.zoneLinkAddForm.get('ddlZone').value,
  //         productcode: this.zoneLinkAddForm.get('ddlProduct').value,
  //         country: this.zoneLinkAddForm.get('ddlCountry').value,
  //         state: this.zoneLinkAddForm.get('ddlState').value,
  //         city: this.zoneLinkAddForm.get('ddlCity').value,
  //     }

  //     this.ngxLoaderService.start();
  //     this.zoneService.Add(reqObj).subscribe((res) => {
  //         if (res && res.success) {
  //             this.zoneService.GetVendor(vendorcode).subscribe((res) => {
  //                 this.ngxLoaderService.stop();
  //                 this.rowData = res?.data ? res.data : this.rowData;
  //             })
  //         }
  //         else if (res && !res?.success) {
  //             this.ngxLoaderService.stop();
  //             this.openWarningDialog(res?.message)
  //         };
  //     })

  //     setTimeout(() => {
  //         this.isZoneAdd = false;
  //     }, 1000);

  //     this.resetZone();
  //     this.ngxLoaderService.stop();
  // }

  // updateZone() {
  //     if (!this.permConfig.isEditAllowed) {
  //         this.openWarningDialog('No access to Edit.');
  //         return;
  //     }
  //     const zonecode = this.zoneLinkAddForm.get('ddlZone')?.value;
  //     const vendorcode = this.zoneForm.get('ddlVendor')?.value;
  //     if (!zonecode || !vendorcode) {
  //         return;
  //     }

  //     const reqObj: any = {
  //         id: this.zoneId,
  //         vendorcode: this.zoneForm.get('ddlVendor').value,
  //         zonecode: this.zoneLinkAddForm.get('ddlZone').value,
  //         productcode: this.zoneLinkAddForm.get('ddlProduct').value,
  //         country: this.zoneLinkAddForm.get('ddlCountry').value,
  //         state: this.zoneLinkAddForm.get('ddlState').value,
  //         city: this.zoneLinkAddForm.get('ddlCity').value,
  //     }

  //     this.ngxLoaderService.start();
  //     this.zoneService.Update(reqObj).subscribe((res) => {
  //         if (res && res?.success) {
  //             this.zoneService.GetVendor(vendorcode).subscribe((res) => {
  //                 this.ngxLoaderService.stop();
  //                 this.rowData = res?.data ? res.data : this.rowData;
  //             })
  //         }
  //         else if (res && !res?.success) {
  //             this.ngxLoaderService.stop();
  //             this.openWarningDialog(res?.message);
  //         }
  //     })
  //     this.resetZone();
  //     this.ngxLoaderService.stop();
  // }

  // deleteRecord(id: any) {
  //     const vendorcode = this.zoneForm.get('ddlVendor')?.value;
  //     this.ngxLoaderService.start();
  //     this.zoneService.Delete(id).subscribe((res) => {
  //         if (res && res?.success) {
  //             this.zoneService.GetVendor(vendorcode).subscribe((res) => {
  //                 this.ngxLoaderService.stop();
  //                 this.rowData = res?.data ? res.data : this.rowData;
  //             })
  //         }
  //         else if (res && !res.success) {
  //             this.ngxLoaderService.stop();
  //             this.openWarningDialog(res?.message);
  //         }
  //     })
  //     this.ngxLoaderService.stop();
  // }

  // resetZone() {
  //     const vendorData = this.zoneForm.get('ddlVendor')?.value;
  //     this.zoneLinkAddForm.reset();
  //     this.zoneForm.get('ddlVendor').setValue(vendorData)
  //     this.isFormSubmitted = false;
  //     this.isZoneAddFormSubmitted = false;
  //     this.isEdit = false;
  // }

  onGridReadyPeriod(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  // openWarningDialog(msg: any) {
  //   Swal.fire({
  //     text: msg,
  //     icon: 'warning',
  //     confirmButtonText: 'Ok',
  //   })
  // }

  async warningDialog(msg?: any) {
    Swal.fire({
      titleText: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  viewAction(cell: any) {
    // if (!this.permConfig.isViewAllowed) {
    //   this.warningDialogBar('No Access to View.');
    // }
    // else if (this.permConfig.isViewAllowed && cell) {
    this.zoneDetailId = cell.id;
    this.bindZoneDetailInfo(this.zoneDetailId);
    // }
  }

  bindZoneDetailInfo(detailid: any) {
    this.zoneService.GetZoneDetailListById(detailid).subscribe(res => {
      try {
        this.ngxLoaderService.start();
        if (res) {
          this.ngxLoaderService.stop();
          if (res?.data?.length) {
            this.rowData = res.data;
            this.showRateDetails = true;
          } else {
            this.showRateDetails = false;
            this.appCoreService.showMessage('No Detail information avialable', 'Opps !', 'warning');
          }
        }
      } catch (error) {
        this.ngxLoaderService.stop();
        console.error(error);
      }
    })
  }

  async deletePeriodAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No Access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      const confirmed = await this.openConfirmationDialogDelete();
      if (confirmed)
        this.ngxLoaderService.start();
      this.zoneService.DeletePeriodById(cell.id).subscribe(res => {
        try {
          if (res && res.success) {
            this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
            this.bindZonePeriod(true);
            this.ngxLoaderService.stop();
          }
        } catch (error) {
          console.error(error);
          this.ngxLoaderService.stop();
        }
      });
    }
    this.ngxLoaderService.stop();
  }

  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No Access to Delete.');
    }
    else if (cell && cell.id && this.permConfig.isDeleteAllowed) {
      const confirmed = await this.openConfirmationDialogDelete();
      if (confirmed)
        this.zoneService.DeleteZoneDetailById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.bindZoneDetailInfo(this.zoneDetailId);
            }
          } catch (error) {
            console.error(error);
          }
        });
    }
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        this.zoneAction(cell.id);
      }
    } catch (e) {
      console.error(e);
    }
  }


  editPeriodAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        this.periodAction(cell.id);
      }
    } catch (e) {
      console.error(e);
    }
  }

  periodAction(cell: any) {
    const modalRef = this.modalService.open(ZoneperiodComponent, this.ngbModalOptions);
    modalRef.componentInstance.cell = cell;
    modalRef.result.then(
      (result) => {
        if (result) {
          this.bindZonePeriod();
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
        if (reason == 'Cross click') {
          // this.bindList();
        }
      }
    );

  }

  zoneAction(cell: any) {
    this.ngxLoaderService.start();
    this.zoneService.GetZonePeriodDetailById(cell).subscribe(async res => {
      if (res){
        this.ngxLoaderService.stop();
        if (res && res.success) {
          this.openZoneDetailDialog(res.data?.[0]);
        }
      }
    });
  }

  openZoneDetailDialog(data: any) {
    const modalRef = this.modalService.open(ZoneDetailComponent, this.ngbModalOptions);
    modalRef.componentInstance.cell = data;
    modalRef.result.then(
      (reason) => {
        if (reason === 'Save Click') {
          // console.log('Closed with: result', result);
          this.appCoreService.showMessage('Record Updated Successfully.', 'Success', 'success')
          this.bindZoneDetailInfo(this.zoneDetailId);
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
        if (reason == 'Cross click') {
          // this.bindList();
        }
      }
    )
  };

  async openConfirmationDialogDelete() {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: "This action is irreversible. Are you sure you want to delete?",
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

}